import { render, staticRenderFns } from "./AppLauncherHeader.vue?vue&type=template&id=38a647dc&scoped=true"
import script from "./AppLauncherHeader.vue?vue&type=script&lang=ts"
export * from "./AppLauncherHeader.vue?vue&type=script&lang=ts"
import style0 from "./AppLauncherHeader.vue?vue&type=style&index=0&id=38a647dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.26_css-loader@7.1.2_webpack@5.104.1__ejs@3.1.1_16f75330cd7a26be942211831baf79a1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a647dc",
  null
  
)

export default component.exports